module.exports = __webpack_public_path__ + "img/01-accessibility-convenience.56a0a5e1.jpg";